/**
* @ngdoc service
* @name  sharebase.sbUserGroupService
* 
* @description 
* A service used to retrieve a ShareBase user group
**/
export function UserGroupServiceFactory(
		$http:ng.IHttpService, 
		pxUriPathService
) {
	return {
		/**
		* @ngdoc method
		* @name sbUserGroupService#getUserGroup
		* @methodOf sharebase.sbUserGroupService
		* @kind function
		*
		* @description
		* Gets a user group
		*
		* @returns {Deferred} A promise that will resolve with a user group
		* 
		*/
		getUserGroup,

		/**
		* @ngdoc method
		* @name sbUserGroupService#getUserGroupPolicy
		* @methodOf sharebase.sbUserGroupService
		* @kind function
		*
		* @description
		* Gets a user group sharing policy
		*
		* @returns {Deferred} A promise that will resolve with a user group's sharing policy
		* 
		*/
		getUserGroupPolicy,

		/**
		* @ngdoc method
		* @name sbUserGroupService#addUserGroup
		* @methodOf sharebase.sbUserGroupService
		* @kind function
		*
		* @description
		* Adds a new user group
		*
		* @returns {Deferred} A promise that will resolve with a user group
		* 
		*/
		addUserGroup,

		/**
		* @ngdoc method
		* @name sbUserGroupService#updateUserGroup
		* @methodOf sharebase.sbUserGroupService
		* @kind function
		*
		* @description
		* Updates an existing user group
		*
		* @returns {Deferred} A promise that will resolve with a user group
		* 
		*/
		updateUserGroup,

		/**
		* @ngdoc method
		* @name sbUserGroupService#updateUserGroupPolicy
		* @methodOf sharebase.sbUserGroupService
		* @kind function
		*
		* @description
		* Updates an existing user group policy
		*
		* @returns {Deferred} A promise that will resolve with a user group policy
		* 
		*/
		updateUserGroupPolicy
	};

	function getUserGroup(userGroupId, systemName) {
		return $http
			.get(pxUriPathService.resolvePath('/{system}/usergroups/' + userGroupId, setDeploymentParam(systemName)))
			.then(function (response) {
				return response.data;
			});
	}

	function getUserGroupPolicy(userGroupId) {
		return $http
			.get(pxUriPathService.resolvePath('/usergroups/' + userGroupId + '/policy-v2'))
			.then(function (response) {
				return response.data;
			});
	}

	function addUserGroup(userGroup, systemName) {
		return $http
			.post(pxUriPathService.resolvePath('/{system}/usergroups', setDeploymentParam(systemName)), userGroup)
			.then(function (response) {
				return response.data;
			});
	}

	function updateUserGroup(userGroup, systemName) {
		return $http
			.post(pxUriPathService.resolvePath('/{system}/usergroups/' + userGroup.UserGroupId, setDeploymentParam(systemName)), userGroup)
			.then(function (response) {
				return response.data;
			});
	}

	function updateUserGroupPolicy(userGroupPolicy) {
		return $http
			.put(pxUriPathService.resolvePath('/usergroups/' + userGroupPolicy.UserGroupId + '/policy-v2'), userGroupPolicy)
			.then(function () {
				return userGroupPolicy;
			});
	}

	function setDeploymentParam(systemName) {
		var params:any = {};
		if (systemName) {
			params.system = systemName;
		}
		return params;
	}
}

UserGroupServiceFactory.$inject = [
	'$http',
	'pxUriPathService'
];



// WEBPACK FOOTER //
// ./src/sharebase/services/userGroupService.ts